import {getIsAgeRestricted} from '../../../../common/getIsAgeRestricted';
import {RankingListViewItem} from '../../../../design-system/organisms/RankingListViewItem/RankingListViewItem';
import {RankingListViewItem as RankingListViewItemType} from '../../../../graphql/generated/types';
import {useLogin} from '../../../../user/useLogin.hook';
import {CommonItemProps} from '../../type';

export function RankingListView({item}: CommonItemProps) {
  const {
    title = '',
    thumbnail,
    badgeList,
    ageGradeBadge,
    statusBadge,
    statusLabelText,
    metaList,
    rank = '',
    scheme,
    ageGrade,
    eventLog,
    selfCensorship,
  } = item as RankingListViewItemType;
  const {user} = useLogin();

  return (
    <RankingListViewItem
      title={title}
      thumbnail={thumbnail}
      badgeList={badgeList}
      ageGradeBadge={ageGradeBadge}
      statusBadge={statusBadge}
      statusLabelText={statusLabelText}
      metaList={metaList}
      rank={rank}
      scheme={scheme}
      isAgeRestricted={getIsAgeRestricted({
        age: user?.age,
        authenticatedAt: user?.authenticatedAt,
        ageGrade,
        selfCensorship,
      })}
      imageLazyLoad={false}
      eventLog={eventLog}
    />
  );
}
